import { Heading, Stack } from "@chakra-ui/react";
import { FC } from "react";
import { Control } from "react-hook-form";
import { borderRadius, borderStyle } from "../../../utils/styles/styles";
import InputFieldComponent from "../../../components/molecule/InputField/InputFieldComponent";
import { renderAccountRoleSpecificFields } from "../helpers/renderAccountRoleSpecificFields";

interface AccountSystemDataFormProps {
  errors: any;
  control: Control<any>;
  isDisabled?: boolean;
  selectedRole?: string;
}

const AccountSystemDataForm: FC<AccountSystemDataFormProps> = ({
  errors,
  control,
  isDisabled,
  selectedRole,
}) => {
  return (
    <Stack
      spacing={4}
      border={borderStyle}
      borderRadius={borderRadius}
      background="gray.50"
      p={6}
    >
      <Heading as="h3" fontSize="2xl">
        Sistema
      </Heading>
      <InputFieldComponent
        label="Perfil"
        name="role"
        type="text"
        register={control.register}
        errors={errors}
        isDisabled={isDisabled}
      />
      {selectedRole &&
        renderAccountRoleSpecificFields(
          selectedRole,
          control,
          errors,
          isDisabled,
        )}
    </Stack>
  );
};

export default AccountSystemDataForm;
